import { transformPlan } from '@dragonfruit/sagas/purchase/transformPlans';
import { formatPriceWithCurrency } from '@dragonfruit/utils/priceParser';
import {
  COURSE,
  LIVE_TOPIC,
  GROUP_PASS,
} from '@dragonfruit/constants/productType';

export function getFirstSelectedCollection(collectionList) {
  const selectedPlanIndex = collectionList.findIndex(
    ({ plan: { isSelected } }) => !!isSelected
  );
  return collectionList[selectedPlanIndex] || {};
}

export function transformCheckoutCollection(rawData) {
  const {
    bannerImageUrl,
    bannerUrl,
    collectionType,
    contentExpiredAt,
    contentStartAt,
    description,
    id,
    isPresaleExpired,
    plan,
    presaleExpiredAt,
    presalePrice,
    presaleStartAt,
    title,
    hasPhysicalMaterial,
  } = rawData;

  const transformedPlan = transformPlan(plan);

  const { currency, displayCurrency } = transformedPlan;
  const displayPresalePrice = formatPriceWithCurrency(
    currency,
    displayCurrency,
    presalePrice
  );

  return {
    bannerImageUrl,
    bannerUrl,
    collectionType,
    contentExpiredAt,
    contentStartAt,
    description,
    displayPresalePrice,
    id,
    isPresaleExpired,
    plan: transformedPlan,
    presaleExpiredAt,
    presalePrice,
    presaleStartAt,
    title,
    hasPhysicalMaterial,
  };
}

export default function transformCheckoutCollectionList(rawDataList) {
  const hasSelectedPlan = rawDataList.some(
    ({ plan: { isSelected } }) => !!isSelected
  );

  return rawDataList.map((rawData, rawDataIndex) => {
    const transformedCheckoutCollection = transformCheckoutCollection(rawData);
    return {
      ...transformedCheckoutCollection,
      ...(!hasSelectedPlan && {
        plan: {
          ...transformedCheckoutCollection.plan,
          isSelected: rawDataIndex === 0,
        },
      }),
    };
  });
}

export function transformBundleContent(bundleContents) {
  if (!bundleContents) return;

  return [].concat(
    ...Object.entries(bundleContents).map(([contentType, contentIds]) => {
      const ids = Array.isArray(contentIds) ? contentIds : [contentIds];

      return ids
        .filter(Boolean)
        .map(id => ({ content_type: contentType, content_id: id }));
    })
  );
}

export function transformBundleLiveTopic(rawData) {
  const { id, name, hashtag, picture } = rawData;

  return {
    id,
    name,
    description: hashtag,
    thumbnailUrl: picture.originalUrl,
    type: LIVE_TOPIC,
  };
}

export function transformBundleCourse(rawData) {
  const {
    id,
    title,
    contentHashtags,
    picture: { largeUrl },
  } = rawData;
  return {
    id,
    name: title,
    description: contentHashtags[0],
    thumbnailUrl: largeUrl,
    type: COURSE,
  };
}

export function transformBundleGroupPass(rawData) {
  const { id, name, courseAmount, picture } = rawData;
  return {
    id,
    name,
    courseAmount,
    thumbnailUrl: picture,
    type: GROUP_PASS,
  };
}



// WEBPACK FOOTER //
// ./app/sagas/purchase/transformCheckoutCollection.js